// Shared section-label formatter for the runtime question cards.
//
// The QuizRuntime engine enriches each item passed to its card with
//   section_name (from the join)
//   section_position (1-based among questions in this section)
//   section_count (total questions in this section)
//
// Cards call formatSectionLabel(item, locale) to produce the eyebrow
// line above their question title, e.g. "Gemüse · Frage 1 von 10".
// Returns an empty string when the section info is unavailable, so
// callers can drive a v-if directly on the result.

const DICT = {
  en: { question: 'Question', of: 'of' },
  de: { question: 'Frage', of: 'von' },
  fr: { question: 'Question', of: 'sur' },
  it: { question: 'Domanda', of: 'di' },
};

function localiseField(field, locale) {
  if (!field || typeof field !== 'object') return '';
  const order = [locale, 'en', 'de', 'fr', 'it'];
  for (const loc of order) {
    const v = field[loc];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }
  return '';
}

/**
 * Build the section-label string for a card. Returns '' when no
 * section_name is set; if section_position/section_count are missing,
 * returns the bare section name (still a useful breadcrumb).
 */
export function formatSectionLabel(item, locale) {
  if (!item) return '';
  const name = localiseField(item.section_name, locale);
  if (!name) return '';
  const pos = item.section_position;
  const count = item.section_count;
  if (!Number.isFinite(pos) || !Number.isFinite(count) || count < 1) {
    return name;
  }
  const dict = DICT[locale] || DICT.en;
  return `${name} · ${dict.question} ${pos} ${dict.of} ${count}`;
}
